import { createRootRoute, Outlet } from '@tanstack/react-router';
//import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
//import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ClerkProvider } from '@clerk/clerk-react';
import App from '@/components/App';
import { CLERK_PUBLIC_KEY } from '@/configuration';

// Clerk dialogs layout configuration
type ButtonPlacement = "bottom" | "top" | undefined;
const socialButtonsPlacement: ButtonPlacement = "bottom";
const appearance = {
  layout: {
    logoImageUrl: "https://practice.longjump.ai/assets/branding.png", 
    socialButtonsPlacement: socialButtonsPlacement
  },
  elements: {
    logoBox: { height: '80px' }
  }
}

export const Route = createRootRoute({
  component: () => (
    <ClerkProvider appearance={appearance} publishableKey={CLERK_PUBLIC_KEY}>
      <App>
        <Outlet />
      </App>
    </ClerkProvider>
  ),
})

/*
            <TanStackRouterDevtools />
            <ReactQueryDevtools initialIsOpen={false} />
*/
